import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-8 text-center">
          {aboutData.title}
        </h2>
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          {aboutData.paragraphs.map((para, i) => (
            <p
              key={i}
              className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 last:mb-0"
            >
              {para}
            </p>
          ))}
          <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/70">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{stat.value}</div>
                <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}